/** Breakpoints: settings.scss ($screen-sm 569, $screen-tablet 768, $screen-md 1003, $screen-lg 1319). */
const BP = { sm: 569, tablet: 768, md: 1003, lg: 1319 };
const mq = (px) => window.matchMedia(`(max-width:${px}px)`).matches;
const remPx = () => parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
const cssLen = (styles, prop) => {
    const v = styles.getPropertyValue(prop).trim();
    if (!v) return 0;
    return v.endsWith('rem') ? parseFloat(v) * remPx() : parseFloat(v) || 0;
};
const gapAndPeek = (track) => {
    const s = getComputedStyle(track);
    return {
        gap: cssLen(s, '--testimonials-carousel-gap') || cssLen(s, 'column-gap') || cssLen(s, 'gap'),
        peek: cssLen(s, '--testimonials-carousel-peek'),
    };
};

export const getTestimonialsRow = (el) => el.closest('#testimonials-row');
export const isTestimonialsCarousel = (el) => Boolean(getTestimonialsRow(el));
export const isTestimonialsEdgeFadeAtViewport = () => !mq(BP.tablet);

export const isTestimonialsScrollableAtViewport = (row) =>
    Boolean(
        row &&
            (row.classList.contains('testimonials-row--cards-many') ||
                (row.classList.contains('testimonials-row--cards-3') && mq(BP.md)) ||
                (row.classList.contains('testimonials-row--cards-2') && mq(BP.sm))),
    );

export const getTestimonialsVisibleCount = (row) => {
    const w = window.innerWidth;
    if (w <= BP.sm) return 1;
    if (w <= BP.md) return 2;
    if (row?.classList.contains('testimonials-row--cards-many') && w <= BP.lg) return 2;
    return 3;
};

export const getTestimonialsMaxSlideIndex = (count, row) => {
    if (count <= 0) return 0;
    return isTestimonialsScrollableAtViewport(row) ? Math.max(0, count - getTestimonialsVisibleCount(row)) : count - 1;
};

/** Hide extra dot nav items when multiple cards are visible; show all when static layout. */
export const syncTestimonialsBulletVisibility = (bullets, slideCount, row) => {
    if (!isTestimonialsScrollableAtViewport(row)) {
        bullets.forEach((bullet) => {
            bullet.hidden = false;
            bullet.removeAttribute('aria-hidden');
        });
        return;
    }

    const visibleCount = getTestimonialsMaxSlideIndex(slideCount, row) + 1;
    bullets.forEach((bullet, index) => {
        const off = index >= visibleCount;
        bullet.hidden = off;
        bullet.toggleAttribute('aria-hidden', off);
    });
};

export const getTestimonialsCarouselTrackOffsetPx = (track, slides, index, row) => {
    if (index <= 0) return 0;
    const width = slides[0]?.offsetWidth || 0;
    if (!width) return 0;

    const { gap, peek } = gapAndPeek(track);
    const step = width + gap;
    if (!peek) return index * step;

    row = row ?? track.closest('#testimonials-row');
    const visible = getTestimonialsVisibleCount(row);
    const max = Math.max(0, slides.length - visible);
    if (index >= max && max > 0) return max * step - peek;
    if (visible === 1 || (visible >= 2 && peek > width * 0.85)) return index * step;
    return index * width + (index - 1) * gap - peek;
};
